"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultPrefix = exports.customMerge = void 0;
var styles_1 = require("@material-ui/core/styles");
var index_1 = __importDefault(require("./index"));
var deepmerge_1 = __importDefault(require("deepmerge"));
var breakpoints_1 = require("./breakpoints");
var jss_1 = require("jss");
var makeCssClass_1 = __importDefault(require("./makeCssClass"));
var customMerge = function () { return function (a, b) { return b == null ? a : deepmerge_1.default(a, b, { customMerge: exports.customMerge }); }; };
exports.customMerge = customMerge;
// A theme with custom primary and secondary color.
// It's optional.
exports.defaultPrefix = "ezd-portal";
function getCssContext(runtimeConfig) {
    var _a, _b;
    var prefix = runtimeConfig.cssPrefix || exports.defaultPrefix;
    var breakpoints = new breakpoints_1.PortalBreakpoints((_b = (_a = runtimeConfig.theme) === null || _a === void 0 ? void 0 : _a.breakpoints) === null || _b === void 0 ? void 0 : _b.values, prefix);
    var theme;
    if (typeof runtimeConfig.theme === 'string' && index_1.default[runtimeConfig.theme]) {
        theme = styles_1.createMuiTheme(index_1.default[runtimeConfig.theme](breakpoints));
    }
    else if (typeof runtimeConfig.theme === 'object') {
        var extendedTheme = index_1.default[runtimeConfig.theme.extends] || (function () { return ({}); });
        theme = styles_1.createMuiTheme(deepmerge_1.default.all([index_1.default.base(breakpoints), extendedTheme(breakpoints), runtimeConfig.theme], { customMerge: exports.customMerge }));
    }
    else {
        theme = styles_1.createMuiTheme(index_1.default.whitelabel(breakpoints));
    }
    return {
        theme: theme,
        // This is needed in order to deduplicate the injection of CSS in the page.
        sheetsManager: new Map(),
        // This is needed in order to inject the critical CSS.
        sheetsRegistry: new jss_1.SheetsRegistry(),
        // The standard class name generator.
        //@ts-ignore
        // generateClassName:
        generateClassName: makeCssClass_1.default(runtimeConfig.cssPrefix || exports.defaultPrefix),
    };
}
exports.default = getCssContext;
//# sourceMappingURL=getCssContext.js.map